import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useMemo } from 'react';
import { professionalMyPageTabsStyle } from '@/components/modules/pages/mypage/professional/Tab/ProfessionalMyPageTab/style';
import { LockIcon } from '@/components/ui/SvgIcon/Variable/SvgIconComponents';
import { BaseTab, BaseTabs } from '@/components/ui/Tab/BaseTab';
import { PROFESSIONAL_MART_DESCRIPTION_PDF_URL } from '@/define/consts/assets';
import { CONSULTANT_COLUMN_GUIDE } from '@/utils/constants/assets/s3';
export const PROFESSIONAL_MYPAGE_TAB_VALUE_RFP = 'rfp';
export const PROFESSIONAL_MYPAGE_TAB_VALUE_SOLUTION = 'solution';
export const PROFESSIONAL_MYPAGE_TAB_VALUE_COLUMN = 'column';
export const PROFESSIONAL_MYPAGE_TAB_VALUE_SEMINAR = 'seminar';
export const ProfessionalMyPageTab = (props) => {
    const { changeSelectedTab, className, isUseProffitMart, selectedTab } = props;
    /** タブの表示内容 */
    const tabs = useMemo(() => [
        { isLocked: false, text: '提案管理', value: 'rfp' },
        { isLocked: !isUseProffitMart, text: '事例掲載', value: 'solution' },
        {
            isLocked: !isUseProffitMart,
            link: CONSULTANT_COLUMN_GUIDE,
            text: 'コラム掲載',
            value: 'column',
        },
        { isLocked: !isUseProffitMart, text: 'セミナー掲載', value: 'seminar' },
    ], [isUseProffitMart]);
    const style = professionalMyPageTabsStyle();
    return (_jsx(BaseTabs, Object.assign({ className: style.tabs({ class: className }) }, { children: tabs.map((tab) => (_jsxs(BaseTab, Object.assign({ activeValue: selectedTab, classNames: {
                button: {
                    active: style.tabButton({ selectedTab: true }),
                    inactive: style.tabButton({ selectedTab: false }),
                },
                tab: {
                    active: style.tab({ selectedTab: true }),
                    inactive: style.tab({ selectedTab: false }),
                },
            }, onChange: changeSelectedTab, target: tab.isLocked ? '_blank' : '_self', to: tab.isLocked ? PROFESSIONAL_MART_DESCRIPTION_PDF_URL : tab.link, value: tab.value }, { children: [_jsx("span", Object.assign({ className: style.text() }, { children: tab.text })), tab.isLocked && _jsx(LockIcon, { color: 'current', size: 'md' })] }), tab.value))) })));
};
